export default function LocationDot({
    diameter = 15,
    borderWidth = 2,
    backgroundColor = '#1da1f2',
    pulseColor = '#1da1f2',
    pulse = false,
    children,
}: {
    diameter?: number
    borderWidth?: number
    backgroundColor?: string
    pulse?: boolean
    pulseColor?: string
    children?: React.ReactNode
}) {
    return (
        <div
            style={{
                backgroundColor: backgroundColor,
                width: `${diameter}px`,
                height: `${diameter}px`,
                borderRadius: '50%',
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {pulse && (
                <div
                    style={{
                        backgroundColor: pulseColor,
                        content: '""',
                        width: `${diameter}px`,
                        height: `${diameter}px`,
                        borderRadius: '50%',
                        position: 'absolute',
                        animation:
                            'maplibregl-user-location-dot-pulse 2s infinite',
                    }}
                ></div>
            )}
            <div
                style={{
                    borderRadius: '50%',
                    border: `${borderWidth}px solid #fff`,
                    content: '""',
                    height: `${diameter + 2 * borderWidth}px`,
                    left: `${-borderWidth}px`,
                    position: 'absolute',
                    top: `${-borderWidth}px`,
                    width: `${diameter + 2 * borderWidth}px`,
                    boxSizing: 'border-box',
                    boxShadow: '0 0 3px rgb(0 0 0 / 35%)',
                }}
            ></div>

            {children}
        </div>
    )
}
